import { TooltipInfo } from "components/info-tooltip";
import { Badge } from "ui/components/badge";
import { Card, CardContent } from "ui/components/card";
import { EvtStatsCardLoader } from "./loader";
import cn from "classnames"

export function EvtStatsCard({
  label,
  value,
  description,
  difference,
  info,
  isLoading = false,
  className = ""
}) {
  // Render label with optional difference badge
  const renderDiffBadge = () => {
    if (difference === undefined || difference === null) {
      return null;
    }

    const isPositive = difference >= 0;
    const sign = isPositive ? "+" : "";

    return (
      <Badge
        className={`px-2 py-1 text-xs font-medium rounded-full ${isPositive
          ? "bg-green-100 text-green-800 border border-green-200"
          : "bg-red-100 text-red-800 border border-red-200"
          }`}
      >
        {sign}
        {difference.toFixed(1)}%
      </Badge>
    );
  };

  if (isLoading) {
    return <EvtStatsCardLoader />;
  }

  return (
    <Card className="rounded-xl shadow-none">
      <CardContent className="flex flex-col gap-2 md:gap-3 ">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-1">
            <h3 className="font-semibold text-primary">{label} </h3>
            {info && <TooltipInfo info={info} />}
          </div>
          {renderDiffBadge()}
        </div>
        <span className={cn("text-3xl md:text-4xl font-bold text-foreground", className)}>
          {value}
        </span>

        {description && (
          <p className="text-base text-muted-foreground">{description}</p>
        )}
      </CardContent>
    </Card>
  );
}
